import '@angular/compiler';
import { Injector } from '@angular/core';
import { Routes } from '@angular/router';
import { HashLocationStrategy, PathLocationStrategy, PlatformLocation } from '@angular/common';
import { RoomReservationComponent } from '../room-reservation/room-reservation.component';
import { MyReservationComponent } from '../room-reservation/components/my-reservation/my-reservation.component';
import { PageNotFoundComponent } from 'src/app/shared/components/page-not-found/page-not-found.component';
import { LogoutComponent } from 'src/app/shared/components/logout/logout.component';
import { DeviceReservationComponent } from '../room-reservation/device-reservation.component';
import { StartPageComponent } from '../room-reservation/components/start-page/start-page.component';
var routes = [
    {
        path: '',
        component: StartPageComponent
    },
    // Räume suchen
    {
        path: 'rooms',
        component: RoomReservationComponent
    },
    {
        path: 'devices',
        component: DeviceReservationComponent
    },
    {
        path: 'my',
        component: MyReservationComponent,
        children: [{
                path: 'confirmation/:id',
                component: MyReservationComponent,
            }]
    },
    {
        path: 'logout',
        component: LogoutComponent,
    },
    { path: '**', component: PageNotFoundComponent }
];
var ɵ0 = function (inj) {
    return (window._RoomReservationConfig || {}).useHashRouting || false
        ? new HashLocationStrategy(inj.get(PlatformLocation))
        : new PathLocationStrategy(inj.get(PlatformLocation));
};
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0 };
